import { ReactElement } from "react";
import Head from "next/head";
import { MainLayout } from "@/containers/layout/NowLayout";
import { faqItems } from "@/components/landing-new/faqs/FaqMainPage/utils";

import StillHaveQuestions from "@/components/landing-new/faqs/StillHaveQuestions/StillHaveQuestions";
import KnowYourBudget from "@/components/landing-new/faqs/KnowYourBudget/KnowYourBudget";

import FaqMainPage from "@/components/landing-new/faqs/FaqMainPage/FaqMainPage";

const FAQs = () => {
  return (
    <>
      <Head>
        <title>Common Questions about Keyzy and Rent To Buy Home Purchasing</title>
        <link rel="canonical" href="https://www.keyzy.com/faqs" />
        <meta
          name="description" key="description"
          content="Common questions about Keyzy's rent to buy solution. Learn about getting a budget, applying to Keyzy, living in your Keyzy home and buying your future home."
        />
        <meta
          name="twitter:card"
          content="Common questions about Keyzy's rent to buy solution. Learn about getting a budget, applying to Keyzy, living in your Keyzy home and buying your future home."
          key="twcard"
        />
        <meta name="twitter:creator" content="keyzyhomes" key="twhandle" />
        <meta property="og:url" content="/" key="ogurl" />
        <meta property="og:image" content="/faqs/keyzy-meta-faqs.png" key="ogimage" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Keyzy" key="ogsitename" />
        <meta
          property="og:title"
          content="Common Questions about Keyzy and Rent To Buy Home Purchasing"
          key="ogtitle"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_GB" />
        <meta
          property="og:description"
          content="Common questions about Keyzy's rent to buy solution. Learn about getting a budget, applying to Keyzy, living in your Keyzy home and buying your future home."
          key="ogdesc"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://keyzy.com/" },
                { "@type": "ListItem", "position": 2, "name": "FAQs", "item": "https://keyzy.com/faqs" },
              ],
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": faqItems.map((faq) => ({
                "@type": "Question",
                "name": faq.question.trim(),
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": faq.answer.replace(/<[^>]*>/g, "").trim(),
                },
              })),
            }),
          }}
        />
      </Head>
      <FaqMainPage />
      <div className="flex flex-col lg:flex-row">
        <div className="lg:w-1/2">
          <StillHaveQuestions />
        </div>
        <div className="lg:w-1/2">
          <KnowYourBudget />
        </div>
      </div>
    </>
  );
};

FAQs.getLayout = function getLayout(page: ReactElement) {
  return <MainLayout theme="light">{page}</MainLayout>;
};

export default FAQs;
